import { css } from "@emotion/css";
import { ThirdPartyLogo } from "@octopusdeploy/design-system-components";
import { borderRadius } from "@octopusdeploy/design-system-tokens";
import { resolveUrl } from "~/utils/resolveUrl";
interface LogoGroupProps {
    logoLinks: string[];
    size?: string;
}
export default function LogoGroup({ logoLinks, size }: LogoGroupProps) {
    return (<div className={styles.container}>
            {logoLinks.map((logoLink) => (<div className={styles.logoContainer} key={logoLink}>
                    <ThirdPartyLogo url={resolveUrl(logoLink)} size={size}/>
                </div>))}
        </div>);
}
const styles = {
    container: css({
        display: "flex",
        marginRight: "10px", // To offset the last logo's negative margin
    }),
    logoContainer: css({
        marginRight: "-20px",
        backgroundColor: "white",
        borderRadius: borderRadius.circle,
        boxShadow: "0 0 3px grey",
    }),
};
